module.exports = __webpack_public_path__ + "img/login.37937365.png";